import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Modal from '@/common/components/Modal/index';
import { useToggle } from '@/common/hooks/index';
import modalStyles from '@/common/styles/modal-form-primary.less';
import styles from '@/common/containers/Modals/TakeBreathe/styles.less';
import Img from '@/common/assets/takeBreathe.png';
import cx from 'classnames';
import { Storage } from '@/common/utils/index';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const TakeBreathe = () => {
  const { t } = useTranslation();
  const copyrightSup = <CopyrightSup />;
  const decedentId = useCurrentDecedentId();
  const [open, toggleOpen] = useToggle(false);

  useEffect(() => {
    if (!Storage.get(`takeBreathe.${decedentId}`)) {
      toggleOpen(true);
    }
  }, [decedentId, toggleOpen]);

  const onClose = () => {
    Storage.set(`takeBreathe.${decedentId}`, 1);
    toggleOpen();
  };

  return (
    <Modal className={modalStyles.modal} open={open} overlay>
      <div className={modalStyles.modalHeader}>
        <h3>{t('Take a breath...')}</h3>
      </div>
      <div className={modalStyles.modalForm}>
        <div className={cx(styles.body, modalStyles.modalBody)}>
          <div className={styles.bodyItem}>
            <p>
              {t(
                'At this point, all this may seem overwhelming and you may have a sense of being swamped by the complexity and volume of work this effort is generating. This is understandable, and it’s OK.'
              )}
            </p>
            <br />
            <p>
              <Trans
                i18nKey="The questions being answered will produce a number of tasks that will take some time to complete. PAEM After Care<copyrightSup/> will guide you through this process, one step at a time, and we will help you keep track of what needs to be done and when it should be done."
                components={{ copyrightSup }}
              />
            </p>
            <br />
            <p>
              {t(
                'This may seem difficult, but it will be OK. With a little patience and persistence, we’ll help you get through this.'
              )}
            </p>
          </div>
          <img src={Img} className={cx(styles.img, styles.bodyItem)} />
        </div>
        <div className={cx(modalStyles.modalFooter, styles.btn)}>
          <Button type="submit" variant="contained" onClick={onClose}>
            {t('Close')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TakeBreathe;
